import { FC } from 'react';
import { AccordionItemStoryblok } from 'storyblok-types';
import { H2, H3 } from 'atoms/Typography';
import { ReactMarkdown } from 'molecules/Markdown';
import { AccordionWithImage } from 'pages/StoryBlok/SeoAccordeon/Accordion';
import { renderRichText } from 'modules/stroyblok/services';
import styles from '../styles.module.css';

export const AccordionItems: FC<{ items: AccordionItemStoryblok[] }> = ({
  items,
}) => {
  return (
    <div className={styles.accordionWrapper}>
      <ul className={styles.list}>
        {items.map((item) => {
          return (
            <AccordionWithImage
              key={item._uid}
              component="li"
              summaryContent={
                <H2 className={styles.collapseTitle}>{item.question}</H2>
              }
              classes={{
                summaryRoot: styles.summaryRoot,
                details: styles.detailsRoot,
              }}
              defaultExpanded={false}
            >
              <ReactMarkdown
                text={renderRichText(item.answer)}
                className={styles.text}
                components={{
                  blockquote: ({ children }) => (
                    <blockquote className={styles.blockquote}>
                      {children}
                    </blockquote>
                  ),
                  h3: ({ children }) => (
                    <H3 className={styles.titleInText}>{children}</H3>
                  ),
                }}
              />
            </AccordionWithImage>
          );
        })}
      </ul>
    </div>
  );
};
